export const REPORTER_SPOTLIGHT = 'reporter-spotlight' as const;
export const ISSUE_ERROR_ANALYTICS = 'issue.error';
